// extracted by mini-css-extract-plugin
var _1 = "TargetHighlight-module__annotation--cVIQ2";
var _2 = "TargetHighlight-module__comment--srZ6E";
var _3 = "TargetHighlight-module__selection--jnGbv";
export { _1 as "annotation", _2 as "comment", _3 as "selection" }
